export default {
  title: "403 Prohibido",
  description:
    "Lo sentimos, no tiene permiso para acceder a esta página. Por favor, contacte a su administrador si cree que esto es un error.",
  goHome: "Ir a la página principal",
  goBack: "Volver atrás",
};
